export default "__VITE_ASSET__C2B9s91q__"